import { DocumentSummary } from '../../../interfaces/DocumentSummary';
import { DocumentSummaryDto } from '../../../interfaces/Dto/DocumentSummaryDto';

export default function transformDocumentSummary(documentSummary: DocumentSummaryDto): DocumentSummary {
  return {
    documentsCount: documentSummary?.newDocumentCount,
    isVisible: documentSummary?.isVisible,
  };
}
